/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import {
  Text as RNText,
  TextProps as RNTextProps,
  TextStyle,
} from "react-native";

export interface TextProps {
  isHeading?: boolean;
  style?: TextStyle;
  children?: React.ReactNode;
}

/**
 * Skale Text component, used primarily for custom ObjectSans font
 */
export default function Text({
  isHeading = false,
  style,
  children,
  ...rest
}: TextProps & RNTextProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const topPaddingSpecified =
    style?.padding !== undefined || style?.paddingTop !== undefined;

  return (
    <RNText
      {...rest}
      style={[
        style,
        {
          fontWeight: isHeading ? "bold" : style?.fontWeight,
          fontFamily: isHeading ? "ObjectSans-Medium" : "ObjectSans-Regular",
          lineHeight:
            style?.lineHeight === undefined ? ("140%" as any) : undefined,
        },
      ]}
    >
      {children}
    </RNText>
  );
}
